const IS_DEV = process.env.NODE_ENV === 'development';
const IS_PRODUCTION = !IS_DEV;

export const Environment = {
    IS_DEV,
    V1_API_PATH: IS_PRODUCTION ? 'https://api.orderx.no' : 'http://localhost:3210',
    V1_PUBLIC_PATH: IS_PRODUCTION ? 'https://appless.no' : 'http://localhost:2900',
    PATH_ADMIN: IS_PRODUCTION ? 'https://admin.orderx.eu' : 'http://localhost:9001',
    isE2e() {
        return Boolean(localStorage.getItem('E2E'));
    },
    APP_VERSION: process.env.REACT_APP_DEPLOYED_AT,
};
